import React from 'react';
import { useUFOReportError } from '@atlaskit/react-ufo/report-error';
export var HubErrorLogger = function HubErrorLogger(_ref) {
  var error = _ref.error,
    shouldForceError = _ref.shouldForceError;
  var logError = useUFOReportError();
  React.useEffect(function () {
    logError({
      name: (error === null || error === void 0 ? void 0 : error.name) || 'unknown',
      errorMessage: (error === null || error === void 0 ? void 0 : error.message) || '',
      errorStack: (error === null || error === void 0 ? void 0 : error.stack) || '',
      forcedError: shouldForceError
    });
  }, [logError, error, shouldForceError]);
  return null;
};